import { useState } from "react";
import { Separator } from "react-resizable-panels";

export const CustomSeparator = ({
	onDoubleClick,
	orientation = "horizontal",
}: {
	onDoubleClick: () => void;
	orientation?: "horizontal" | "vertical";
}) => {
	const [hover, setHover] = useState(false);

	const isSideBySide = orientation === "horizontal";
	const thickness = hover ? "10px" : "8px";

	return (
		<Separator
			onDoubleClick={onDoubleClick}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				width: isSideBySide ? thickness : "auto",
				height: isSideBySide ? "auto" : thickness,
				background: hover ? "#bdbdbd" : "#e0e0e0",
				position: "relative",
				cursor: isSideBySide ? "col-resize" : "row-resize",
				marginLeft: isSideBySide ? 5 : 0,
				marginRight: isSideBySide ? 5 : 0,
				marginTop: isSideBySide ? 0 : 5,
				marginBottom: isSideBySide ? 0 : 5,
				borderRadius: 10,
			}}
		>
			<div
				style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: isSideBySide ? "3px" : "40px",
					height: isSideBySide ? "40px" : "3px",
					background: hover ? "#616161" : "#9e9e9e",
					borderRadius: "2px",
				}}
			/>
		</Separator>
	);
};
